import i18n from "i18next";

import enTranslation from "./assets/locales/en/translation.json";

i18n.addResourceBundle("en", "translation", enTranslation, true);

export default i18n;
